import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState: TargetGroupDetails = {
  TargetGroupID: '',
  CreatedAtUTC: '',
  Name: '',
  inviteCodeSegmentName: '',
  CampaignType: '',
  Manual: false,
  TargetGroupUserCount: 0,
  availableProviders: [],
  excludedProviders: [],
  welcomeMessage: '',
  welcomeDescription: '',
  welcomeButtonLabel: '',
  CampaignID: '',
  selectedLanguage: '',
  selectedLanguageName: '',
  defaultLanguage: {
    Name: '',
    Title: '',
    Description: '',
    WelcomeTitle: '',
    WelcomeDescription: '',
    WelcomeButtonLabel: ''
  },
  translations: {
    Name: '',
    Title: '',
    Description: '',
    WelcomeTitle: '',
    WelcomeDescription: '',
    WelcomeButtonLabel: '',
    LanguageCode: null
  }
}

export const targetGroupSlice = createSlice({
  name: 'targetGroup',
  initialState,
  reducers: {
    setTargetGroupInfo: (state, action: PayloadAction<TargetGroupDetails>) => {
      return action.payload
    },
    setSegmentSelectedTranslations: (
      state,
      action: PayloadAction<SetSegmentTranslationParms>
    ) => {
      return {
        ...state,
        selectedLanguage: action.payload.selectedLanguage,
        selectedLanguageName: action.payload.selectedLanguageName,
        defaultLanguage: action.payload.defaultLanguage,
        translations: {
          Name: action.payload.translations?.Name ?? null,
          Title: action.payload.translations?.Title ?? null,
          Description: action.payload.translations?.Description ?? null,
          WelcomeTitle: action.payload.translations?.WelcomeTitle ?? null,
          WelcomeDescription:
            action.payload.translations?.WelcomeDescription ?? null,
          WelcomeButtonLabel:
            action.payload.translations?.WelcomeButtonLabel ?? null
        }
      }
    }
  }
})

export const { setTargetGroupInfo, setSegmentSelectedTranslations } =
  targetGroupSlice.actions
export const targetGroupReducer = targetGroupSlice.reducer
